import script from "./PackageCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackageCard.vue?vue&type=script&lang=ts&setup=true"

import "./PackageCard.vue?vue&type=style&index=0&id=c11fd5e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c11fd5e0"]])

export default __exports__